(() => {
  if (window.lbPartDesign) { window.lbPartDesign.refresh(); return; }
  let scheduled = false;
  const applied = new Map();
  const nativeScopes = new Set();
  const watchedRoots = new WeakSet();
  const mobile = matchMedia('(max-width:768px)');
  function read(node, key) { return key === 'text' ? node.nodeValue : node.getAttribute(key); }
  function write(node, key, value) {
    if (read(node, key) === value) return;
    if (key === 'text') node.nodeValue = value;
    else if (value === null) node.removeAttribute(key);
    else node.setAttribute(key, value);
  }
  function menuOwnerTargets(targets, data) {
    if (data.lbRuleSelector !== '.lb-menu-thumb' || data.lbRuleMenuOwnerUrl === undefined && data.lbRuleMenuOwnerTitle === undefined) return targets;
    const requested = (data.lbRuleMenuOwnerUrl || '').trim(), title = (data.lbRuleMenuOwnerTitle || '').trim();
    if (!requested) return [];
    let chosen;
    try { chosen = new URL(requested, location.href); } catch (_) { return []; }
    if (!/^https?:$/.test(chosen.protocol)) return [];
    return targets.filter(node => {
      const href = node.getAttribute('data-lb-menu-owner-url');
      if (href === null) return false;
      let owner;
      try { owner = new URL(href, location.href); } catch (_) { return false; }
      if (owner.href !== chosen.href) return false;
      if (href.trim().startsWith('#')) return !!title && (node.getAttribute('data-lb-menu-owner-title') || '').trim() === title;
      return !title || (node.getAttribute('data-lb-menu-owner-title') || '').trim() === title;
    });
  }
  function refresh() {
    scheduled = false;
    const scopeTargets = new Map();
    document.querySelectorAll('[data-lb-native-scope-selector]').forEach(registry => {
      const data = registry.dataset;
      if (!data.lbNativeScopeSection || !data.lbNativeScopeSelector) return;
      let nodes;
      try { nodes = document.querySelectorAll(data.lbNativeScopeSelector); } catch (_) { return; }
      nodes.forEach(node => {
        const scope = scopeTargets.get(node) || {sections:new Set(),block:null};
        scope.sections.add(data.lbNativeScopeSection);
        if (data.lbNativeScopeBlock) scope.block = data.lbNativeScopeBlock;
        scopeTargets.set(node, scope);
      });
    });
    nativeScopes.forEach(node => {
      if (!scopeTargets.has(node)) {
        write(node, 'data-lb-native-design-section', null);
        write(node, 'data-lb-native-design-block', null);
        nativeScopes.delete(node);
      }
    });
    scopeTargets.forEach((scope,node) => {
      nativeScopes.add(node);
      write(node, 'data-lb-native-design-section', [...scope.sections].join(' '));
      write(node, 'data-lb-native-design-block', scope.block);
    });
    const desired = new Map(), matches = new Map(), targetCache = new Map();
    const shadowStyles = new Map();
    document.querySelectorAll('template[data-lb-shadow-style]').forEach(template => {
      const root = document.querySelector(template.dataset.lbShadowRoot)?.shadowRoot;
      if (!root) return;
      if (!shadowStyles.has(root)) shadowStyles.set(root, []);
      shadowStyles.get(root).push(template.content.textContent);
    });
    document.querySelectorAll('#lb-bis-host').forEach(host => {
      const root = host.shadowRoot; if (!root) return;
      let style = root.querySelector('style[data-lb-shadow-design]');
      const css = (shadowStyles.get(root) || []).join('\n');
      if (!css && style) { style.remove(); return; }
      if (!css) return;
      if (!style) { style = document.createElement('style'); style.dataset.lbShadowDesign = ''; root.appendChild(style); }
      if (style.textContent !== css) style.textContent = css;
    });
    function want(node, key, value) {
      if (!desired.has(node)) desired.set(node, new Map());
      desired.get(node).set(key, value);
    }
    document.querySelectorAll('[data-lb-design-rule]').forEach(rule => {
      const data = rule.dataset, id = data.lbDesignRule, number = Number(data.lbRuleInstance);
      if (!Number.isSafeInteger(number) || number < 0) return;
      if (!data.lbRuleSelector) return;
      const context = data.lbRuleRoot ? document.querySelector(data.lbRuleRoot)?.shadowRoot : document;
      if (!context) return;
      if (context !== document && !watchedRoots.has(context)) { watchedRoots.add(context); new MutationObserver(schedule).observe(context, {childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','href','placeholder']}); }
      if (data.lbRuleCapabilities === '' && number === 0 && !(data.lbRuleSelector === '.lb-menu-thumb' && (data.lbRuleMenuOwnerUrl !== undefined || data.lbRuleMenuOwnerTitle !== undefined))) return;
      let targets;
      try {
        let selectors = targetCache.get(context);
        if (!selectors) { selectors = new Map(); targetCache.set(context, selectors); }
        if (!selectors.has(data.lbRuleSelector)) selectors.set(data.lbRuleSelector, [...context.querySelectorAll(data.lbRuleSelector)]);
        targets = selectors.get(data.lbRuleSelector);
      } catch (_) { return; }
      targets = menuOwnerTargets(targets, data);
      if (number > 0) targets = targets[number - 1] ? [targets[number - 1]] : [];
      const responsive = key => mobile.matches ? data[key + 'Mobile'] : data[key];
      const capabilities = (data.lbRuleCapabilities || '').split(/\s+/);
      targets.forEach(node => {
        if (number > 0 || data.lbRuleSelector === '.lb-menu-thumb' && (data.lbRuleMenuOwnerUrl !== undefined || data.lbRuleMenuOwnerTitle !== undefined)) {
          if (!matches.has(node)) matches.set(node, []);
          matches.get(node).push(id);
        }
        const textValue = responsive('lbRuleText');
        const placeholderValue = responsive('lbRulePlaceholder');
        const linkValue = responsive('lbRuleLink');
        const newtabValue = responsive('lbRuleNewtab');
        const imageAlt = responsive('lbRuleImageAlt');
        if (capabilities.includes('text') && textValue !== undefined && textValue.trim()) {
          if (data.lbRuleSelector === '.lb-footer-wordmark' && node.matches('.site-footer .lb-footer-wordmark[aria-hidden="true"]')) want(node, 'data-lb-designer-wordmark-text', textValue);
          else if (node.matches('input[type="submit"],input[type="button"]')) want(node, 'value', textValue);
          else {
            const cartTermsAnchor = node.matches('#CartDrawerForm .cart__terms label,#CartPageForm .cart__terms label') ? node.querySelector('a') : null;
            const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT), textNodes = [];
            let text;
            const inactiveDevice = mobile.matches ? '.lb-device-desktop,.lb-native-desktop,lb-native-desktop' : '.lb-device-mobile,.lb-native-mobile,lb-native-mobile';
            while ((text = walker.nextNode())) {
              const original = applied.get(text)?.get('text')?.original || text.nodeValue;
              if (original.trim() && !text.parentElement.closest('svg,script,style,.visually-hidden,.sr-only,[hidden],'+inactiveDevice) && (!cartTermsAnchor || !text.parentElement.closest('a'))) textNodes.push(text);
            }
            if (!cartTermsAnchor || (textNodes[0] && (textNodes[0].compareDocumentPosition(cartTermsAnchor) & Node.DOCUMENT_POSITION_FOLLOWING))) {
              textNodes.forEach((text, index) => want(text, 'text', index ? '' : cartTermsAnchor ? textValue.trimEnd() + ' ' : textValue));
            }
          }
        }
        if (capabilities.includes('placeholder') && placeholderValue !== undefined && node.matches('input,textarea')) want(node, 'placeholder', placeholderValue);
        if (capabilities.includes('image')) {
          const url = mobile.matches ? data.lbRuleImageMobile : data.lbRuleImage;
          const images = node.matches('img') ? [node] : [...node.querySelectorAll('img')];
          if (images.length === 1 && imageAlt !== undefined) want(images[0], 'alt', imageAlt);
          if (url && images.length === 1) {
            const img = images[0];
            want(img, 'src', url);
            want(img, 'srcset', null);
            want(img, 'sizes', null);
            ['data-src','data-srcset'].forEach(key => { if (img.hasAttribute(key)) want(img, key, url); });
            const picture = img.closest('picture');
            if (picture) picture.querySelectorAll('source').forEach(source => want(source, 'srcset', url));
          }
        }
        if (capabilities.includes('link') && linkValue) {
          const anchor = node.matches('a') ? node : node.closest('a');
          if (anchor && !/^(javascript|data):/i.test(linkValue.trim())) {
            want(anchor, 'href', linkValue);
            want(anchor, 'target', newtabValue === 'true' ? '_blank' : null);
            if (newtabValue === 'true') {
              const originalRel = applied.get(anchor)?.get('rel')?.original || anchor.getAttribute('rel') || '';
              want(anchor, 'rel', [...new Set((originalRel+' noopener noreferrer').split(/\s+/).filter(Boolean))].join(' '));
            }
          }
        }
      });
    });
    [document, ...[...document.querySelectorAll('#lb-bis-host')].map(n => n.shadowRoot).filter(Boolean)].forEach(context => context.querySelectorAll('[data-lb-rule-match]').forEach(node => {
      if (!matches.has(node)) node.removeAttribute('data-lb-rule-match');
    }));
    matches.forEach((ids, node) => write(node, 'data-lb-rule-match', ids.join(' ')));
    const releases = [];
    applied.forEach((properties, node) => {
      properties.forEach((entry, key) => {
        if (!node.isConnected || !desired.get(node)?.has(key)) {
          const restoring = node.isConnected && read(node, key) === entry.value;
          if (restoring) write(node, key, entry.original);
          properties.delete(key);
          releases.push({ node, key, release: { original: entry.original, restored: restoring && node.isConnected && read(node, key) === entry.original } });
        }
      });
      if (!properties.size) applied.delete(node);
    });
    desired.forEach((properties, node) => {
      if (!applied.has(node)) applied.set(node, new Map());
      const previous = applied.get(node);
      properties.forEach((value, key) => {
        const entry = previous.get(key) || { original: read(node, key) };
        entry.value = value;
        previous.set(key, entry);
        write(node, key, value);
      });
    });
    releases.forEach(({ node, key, release }) => window.lbNativeContent?.detailReleased?.(node, key, release));
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } }
  window.lbPartDesign = { refresh, owns: (node, key) => applied.get(node)?.has(key) || false };
  refresh();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src','srcset','href','placeholder'] });
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:block:select', event => {
    const rule = event.target.matches('[data-lb-design-rule]') ? event.target : event.target.querySelector('[data-lb-design-rule]');
    if (!rule) return;
    refresh();
    const number = Number(rule.dataset.lbRuleInstance);
    if (!Number.isSafeInteger(number) || number < 0) return;
    const context = rule.dataset.lbRuleRoot ? document.querySelector(rule.dataset.lbRuleRoot)?.shadowRoot : document;
    if (!context) return;
    const matches = menuOwnerTargets([...context.querySelectorAll(rule.dataset.lbRuleSelector)], rule.dataset);
    const target = matches[number > 0 ? number - 1 : 0];
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
